<template>
<div class="form__item">
    <label :for="id">
        <slot name="label"></slot>
        <span v-if="required == true" style="color: red;">*</span>
    </label>
    <div v-if="checkbox == true">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="(option, key) in inputValue" :key="option.id" class="input__checkbox--container-inline">
                <input v-model="inputValue[key]"  class="input__checkbox" type="checkbox" :name="key" :value="key" :aria-label="key" :disabled="disabled" :required="required">
                <span class="input__checkbox--text">{{key}}</span>
            </label>
        </div>
        <div v-else>
            <label v-for="(option, key) in inputValue" :key="option.id" class="input__checkbox--container">
                <input v-model="inputValue[key]" class="input__checkbox" type="checkbox" :name="key" :value="key" :aria-label="key" :disabled="disabled" :required="required">
                <span class="input__checkbox--text">{{key}}</span>
            </label>
        </div>
    </div>

    <div v-if="radio == true">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="option in inputValue.options" :key="option.id" class="input__radio--container-inline">
                <input @click='checkClick' v-model="inputValue.results" class="input__radio" type="radio" :name="id" :value="option" :aria-label="option" :disabled="disabled" :required="required" ref='input' >
                <span class="input__radio--text">{{option}}</span>
            </label>
        </div>
        <div v-else>
            <label v-for="option in inputValue.options" :key="option.id" class="input__radio--container">
                <input @click='checkClick' v-model="inputValue.results" class="input__radio" type="radio" :name="id" :value="option" :aria-label="option" :disabled="disabled" :required="required" ref='input' >
                <span class="input__radio--text">{{option}}</span>
            </label>
        </div>
    </div>

    <div v-if="toggle == true">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="(option, key) in inputValue" :key="option.id" class="input__toggle--container-inline">
                <input v-model="inputValue[key]" class="input__toggle" type="checkbox" :name="id" :value="option" :aria-label="option" :disabled="disabled" :required="required" ref='input' >
                <span class="input__toggle--switch"></span>
                <label class="input__toggle--text">{{key}}</label>
            </label>
        </div>
        <div v-else>
            <label v-for="(option, key) in inputValue" :key="option.id" class="input__toggle--container">
                <input v-model="inputValue[key]" class="input__toggle" type="checkbox" :name="id" :value="option" :aria-label="option" :disabled="disabled" :required="required" ref='input' >
                <span class="input__toggle--switch"></span>
                <label class="input__toggle--text">{{key}}</label>
            </label>
        </div>
    </div>

    <div v-if="select == true">
        <label class="input__select--container">
            <select v-model="inputValue.results" class="input__select" ref='input'  :required="required" :disabled="disabled" aria-label="select">
                <option value='Choose your option' disabled selected>Choose your option</option>
                <option v-for="option in inputValue.options" :key="option.key" :value="option">{{option}}</option>
            </select>
        </label>
    </div>
</div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
        required: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false},
        checkbox: {type: Boolean, default: false},
        radio: {type: Boolean, default: false},
        toggle: {type: Boolean, default: false},
        select: {type: Boolean, default: false},
        inline: {type: Boolean, default: false},
        value: {default: null}
    },
    mounted() {
        if(this.select && this.value.results.length == 0){
            this.value.results = 'Choose your option'
        } 
        this.autofocus ? this.$refs.input.focus() : ''
    },
    computed: {
        inputValue: {
            get () {
                return this.value
            },
            set (value) {
                this.emitValue(value)
            }
        },
        classes () {
            const { inline } = this
            
            return [
                ...(inline ? [`inline`] : null),
            ]
        },
    },
    methods: {
        emitValue (value) {
            this.$emit('input', value)
        },  
        checkClick (e) {
            const radio = document.getElementsByName(e.target.name);
            for (let i = 0; i < radio.length; i++) {
                if(radio[i] != e.target){
                    radio[i].classList.remove('checked');
                }
            }
            if(e.target.classList.contains('checked')){
                e.target.classList.remove('checked')
                e.target.checked = false
                this.value.results = ''
            } else {
                e.target.classList.add('checked')
                e.target.checked = true
            }
        }
    }
}
</script>